const formatPhoneNumber = (n: string): string => n.replace(/\s/g, '-')

export default formatPhoneNumber
